import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import GoalComponent from "../components/GoalComponent";

const GoalDetailsDialog = ({ open, onClose, selectedGoal }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          pb: 0,
        }}>
        <Typography
          variant="h6"
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            color: "#1565C0",
            flexGrow: 1,
          }}>
          Goal Details
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ color: "grey.500" }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent>
        {selectedGoal && (
          <GoalComponent
            key={selectedGoal.id}
            goalid={selectedGoal.id}
            goalvalues={selectedGoal}
            isdisabled={true}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default GoalDetailsDialog;
